import { serverFetch } from "@core/server";
import { fetchSprTov } from "@components/health/clients/health-clients-api";

const nutrition = (path, options) => serverFetch(`nutrition${path ? `/${path}` : ""}`, options);

export const fetchNutritionLookups = () => nutrition("lookups");
export const fetchNutritionTemplates = () => nutrition("templates");
export const fetchNutritionTemplate = (id) => nutrition(`templates/${id}`);
export const createNutritionTemplate = (bodyData) =>
  nutrition("templates", { method: "POST", bodyData });
export const updateNutritionTemplate = (id, bodyData) =>
  nutrition(`templates/${id}`, { method: "PUT", bodyData });
export const deleteNutritionTemplate = (id) =>
  nutrition(`templates/${id}`, { method: "DELETE" });

export const fetchNutritionTables = () => nutrition("tables");
export const createNutritionTable = (bodyData) =>
  nutrition("tables", { method: "POST", bodyData });
export const updateNutritionTable = (id, bodyData) =>
  nutrition(`tables/${id}`, { method: "PUT", bodyData });
export const deleteNutritionTable = (id) =>
  nutrition(`tables/${id}`, { method: "DELETE" });

export const fetchNutritionMap = (dateBeg, dateEnd, hallId) =>
  nutrition("map", { queryParams: { dateBeg, dateEnd, hallId } });
export const fetchUnassignedGuests = (dateBeg, dateEnd) =>
  nutrition("map/unassigned", { queryParams: { dateBeg, dateEnd } });
export const fetchAssignedGuests = (date, tableId) =>
  nutrition("map/assigned", { queryParams: { date, tableId } });
export const seatNutritionGuest = (idDoc, tableId) =>
  nutrition("map/seat", { method: "POST", bodyData: { idDoc, tableId } });
export const unseatNutritionGuest = (idDoc) =>
  nutrition(`map/unseat/${idDoc}`, { method: "POST", bodyData: {} });
export const fetchNutritionTableItems = (date, tableId) =>
  nutrition("map/items", { queryParams: { date, tableId } });
export const createNutritionTableItem = (date, tableId, bodyData) =>
  nutrition("map/items", { method: "POST", queryParams: { date, tableId }, bodyData });
export const updateNutritionTableItem = (date, tableId, idStr, bodyData) =>
  nutrition(`map/items/${idStr}`, {
    method: "PUT",
    queryParams: { date, tableId },
    bodyData
  });
export const deleteNutritionTableItem = (date, tableId, idStr) =>
  nutrition(`map/items/${idStr}`, {
    method: "DELETE",
    queryParams: { date, tableId }
  });
export const bulkFillNutritionItems = (bodyData) =>
  nutrition("map/items/bulk-fill", { method: "POST", bodyData });

export const fetchNutritionRegistration = (date, part, idBranch) =>
  nutrition("registration", { queryParams: { date, part, idBranch } });
export const lookupNutritionCard = (key, date, part, idBranch) =>
  nutrition("registration/card", { queryParams: { key, date, part, idBranch } });
export const registerNutritionGuest = (bodyData) =>
  nutrition("registration/register", { method: "POST", bodyData });
export const cancelNutritionRegistration = (bodyData) =>
  nutrition("registration/cancel", { method: "POST", bodyData });

export const fetchNutritionCalc = (dateBeg, dateEnd, idBranch) =>
  nutrition("calc", { queryParams: { dateBeg, dateEnd, idBranch } });
export const replaceNutritionCalcDay = (date, bodyData) =>
  nutrition(`calc/${date}`, { method: "PUT", bodyData });

export const searchNutritionProducts = (query) => fetchSprTov(query);

export const fetchClientDailyMeals = (idDoc, idStr) =>
  serverFetch(`doc-exp/${idDoc}/clients/${idStr}/daily-meals`);
export const replaceClientDailyMeals = (idDoc, idStr, bodyData) =>
  serverFetch(`doc-exp/${idDoc}/clients/${idStr}/daily-meals`, {
    method: "PUT",
    bodyData
  });
